import { track, getAnonymousUserID } from '@hotjar/webapp/domains/common/tracking/segment';
import type { Recording } from '@hotjar/webapp/features/Playbacks/types';

/* eslint-disable camelcase */
type GroupData = {
  site_id: number;
  organization_id: number;
  account_id: number;
};

type SingleEventData = {
  element_name: string;
  ui_position: string;
  state_event_was_triggered_on?: string;
  url_event_was_triggered_on?: string;
};

type SingleExperimentData = {
  experiment_id: string;
  experiment_target_id: string;
  variation_id: number | string;
  user_id: number | string;
};

type SingleRecordingFeedbackLeftData = {
  recording_id: number;
  ui_position: string;
  point_in_timeline_seconds: number;
  point_in_timeline_playback_percentage: number;
  feedback_given: string;
};

/* eslint-enable camelcase */

/**
 * Get tracking group data from the recording
 * @param recording
 */
export function getGroupDataForRecording(recording: Recording): GroupData {
  return {
    site_id: recording.site_id,
    organization_id: recording.organization_id,
    account_id: recording.account_id,
  };
}

export const trackShareModalOpen = (recording: Recording, uiPosition: string): void => {
  const trackingData = {
    ...getGroupDataForRecording(recording),
    modal_name: 'playback_sharing_modal',
    modal_version: 'playback_sharing_modal',
    state_event_was_triggered_on: 'playback.player',
    ui_position: uiPosition,
  };

  track('Modal Loaded', trackingData);
};

export const trackClick = (recording: Recording, trackingData: SingleEventData): void => {
  const mergedTrackingData = {
    ...getGroupDataForRecording(recording),
    ...trackingData,
  };

  track('Element Clicked', mergedTrackingData);
};

export const trackExperimentViewed = (
  recording: Recording,
  trackingData: SingleExperimentData,
): void => {
  const mergedTrackingData = {
    ...getGroupDataForRecording(recording),
    ...trackingData,
  };

  track('Experiment Viewed', mergedTrackingData);
};

export const trackRecordingFeedbackLeft = (
  recording: Recording,
  trackingData: SingleRecordingFeedbackLeftData,
): void => {
  const mergedTrackingData = {
    ...getGroupDataForRecording(recording),
    ...trackingData,
  };

  track('Recording Feedback Left', mergedTrackingData);
};

export const trackElementViewed = (recording: Recording, trackingData: SingleEventData): void => {
  const mergedTrackingData = {
    ...getGroupDataForRecording(recording),
    ...trackingData,
  };

  track('Element Viewed', mergedTrackingData);
};

export const getAnonymousId = getAnonymousUserID;
